<template>
  <fragment>
    <ExpansionPanelFilters class="my-4">
      <v-form
        @submit.prevent="filterByAffiliate"
        class="search-forms"
        ref="form"
      >
        <v-row>
          <v-col cols="12" md="3" sm="4">
            <BaseTextField
              v-model="filter.pesquisar"
              :placeholder="$t('reports.search')"
              @input="handleSearch"
              append-icon="mdi-magnify"
              single-line
              hide-details
              clearable
            ></BaseTextField>
          </v-col>

          <v-col cols="12" md="3" sm="4">
            <date-time-picker
              :label="$t('reports.initial-date')"
              @formatted-date="handleInitDateTime"
            ></date-time-picker>
          </v-col>

          <v-col cols="12" md="3" sm="4">
            <date-time-picker
              :label="$t('reports.final-date')"
              @formatted-date="handleEndDateTime"
            ></date-time-picker>
          </v-col>

          <v-col class="d-flex justify-end">
            <BaseButton
              variant="filter"
              type="submit"
              :loading="affiliatesReportLoading"
            >
              {{ $t("reports.filter") }}
            </BaseButton>
          </v-col>
        </v-row>
      </v-form>
    </ExpansionPanelFilters>

    <v-data-table
      class="rounded-lg"
      :no-data-text="$t('reports.no-info-found')"
      :loading-text="$t('reports.loading-info')"
      mobile-breakpoint="0"
      :sort-desc="true"
      :loading="affiliatesReportLoading"
      :items="orderedAffiliates"
      :headers="headers"
      :items-per-page="10"
      :header-props="{
        class: 'rounded-t-lg',
        color: $config.dados.corinputs,
      }"
      :footer-props="{
        class: 'rounded-b-lg',
        itemsPerPageOptions: [10, 20, 50],
        itemsPerPageText: $t('reports.sales-per-page'),
      }"
    >
      <template v-slot:item.comissao_afiliado="{ item }">
        {{ item.comissao_afiliado | moeda }}
      </template>
      <template v-slot:item.desconto_afiliado="{ item }">
        {{ item.desconto_afiliado | moeda }}
      </template>
      <template v-slot:item.valor_total="{ item }">
        {{ item.valor_total | moeda }}
      </template>
      <template v-slot:item.action="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              :color="$config.dados.corinputs"
              height="10"
              width="10"
              small
              icon
              v-bind="attrs"
              v-on="on"
              @click="openDialog(item.idafiliado)"
            >
              <v-icon>mdi-table-large</v-icon>
            </v-btn>
          </template>
          <span>
            {{ $t("reports.sales-by-affiliate.details-by-affiliate") }}
          </span>
        </v-tooltip>
      </template>
      <template
        v-for="(totais, index) in allAffiliatesReport.totals"
        v-slot:body.append
      >
        <tr :key="index" class="text-end font-weight-bold total-row">
          <td class="text-start">Total</td>
          <v-spacer> </v-spacer>
          <td>{{ totais.comissao_afiliado | moeda }}</td>
          <td>{{ totais.desconto_afiliado | moeda }}</td>
          <td>{{ totais.qtd_itens }}</td>
          <td>{{ totais.valor_total | moeda }}</td>
          <v-spacer></v-spacer>
        </tr>
      </template>
    </v-data-table>
    <AffiliateDetail :idafiliado="idafiliado" />
  </fragment>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import dayjs from "dayjs";
import _ from "lodash";
import BaseTextField from "@/components/forms/BaseTextField.vue";
import BaseButton from "@/components/forms/BaseButton.vue";
import DateTimePicker from "@/components/forms/DateTimePicker.vue";
import AffiliateDetail from "@/components/relatorios/AffiliateDetail.vue";
import ExpansionPanelFilters from "@/components/forms/ExpansionPanelFilters.vue";
export default {
  name: "Affiliate",
  components: {
    DateTimePicker,
    BaseTextField,
    BaseButton,
    AffiliateDetail,
    ExpansionPanelFilters,
  },
  data() {
    return {
      idafiliado: "",
      filter: {
        pesquisar: "",
        initDateTime: "",
        endDateTime: "",
      },
      dayjs: dayjs,
    };
  },
  computed: {
    ...mapGetters([
      "intervalDates",
      "storeSequencial",
      "allAffiliatesReport",
      "affiliatesReportLoading",
      "dialogAffiliateDetail",
      "idProduto",
    ]),
    orderedAffiliates() {
      return _.orderBy(this.allAffiliatesReport.info, ["qtd_itens"], ["desc"]);
    },
    headers() {
      return [
        {
          text: this.$t("reports.sales-by-affiliate.title"),
          align: "start",
          value: "nome",
          width: 130,
        },
        {
          text: this.$t("reports.sales-by-affiliate.email"),
          align: "start",
          value: "email",
          width: 90,
        },
        {
          text: this.$t("reports.sales-by-affiliate.commission"),
          align: "end",
          value: "comissao_afiliado",
          width: 110,
        },
        {
          text: this.$t("reports.sales-by-affiliate.discount"),
          align: "end",
          value: "desconto_afiliado",
          width: 110,
        },
        {
          text: this.$t("reports.sales-by-affiliate.sold-quantity"),
          align: "end",
          value: "qtd_itens",
          width: 140,
        },
        {
          text: this.$t("reports.sales-by-affiliate.sold-value"),
          align: "end",
          value: "valor_total",
          width: 120,
        },
        {
          text: this.$t("reports.sales-by-affiliate.details"),
          align: "center",
          value: "action",
          sortable: false,
          width: 120,
        },
      ];
    },
  },
  methods: {
    ...mapActions(["fetchAffiliates", "fetchAffiliateDetail"]),
    ...mapMutations(["setReportsFilter", "setDialogAffiliateDetail"]),
    openDialog(id) {
      this.idafiliado = id;
      this.setDialogAffiliateDetail(!this.dialogAffiliateDetail);
      this.fetchAffiliateDetail({
        producerId: this.storeSequencial,
        idafiliado: id,
      });
    },
    filterByAffiliate() {
      let filter = {};

      if (this.filter.initDateTime) {
        Object.assign(filter, {
          dthr_pedi_ini: this.filter.initDateTime,
        });
      }

      if (this.filter.endDateTime) {
        Object.assign(filter, {
          dthr_pedi_fim: this.filter.endDateTime,
        });
      }

      Object.assign(filter, {
        producerId: this.storeSequencial,
        idproduto: this.idProduto,
        pesquisar: this.filter.pesquisar,
      });

      this.fetchAffiliates(filter);
      this.setReportsFilter(filter);
    },
    handleSearch: _.debounce(function (event) {
      this.filter.pesquisar = event;
      this.filterByAffiliate();
    }, 500),
    handleInitDateTime(formatteddatetime) {
      this.filter.initDateTime = formatteddatetime;
    },
    handleEndDateTime(formatteddatetime) {
      this.filter.endDateTime = formatteddatetime;
    },
  },
  mounted() {
    this.filterByAffiliate();
  },
  destroyed() {
    this.filter = {
      pesquisar: "",
      initDateTime: "",
      endDateTime: "",
    };
  },
};
</script>
<style scoped></style>
